import React, { useState, useEffect, useRef } from 'react';
import { handleChange, handleSubmit } from "../../Controller/CreateSupplierController";
import CountryService from "../../../Setup/controller/CountryController/CountryController";
import TaxService from "../../../Setup/controller/TaxCodesController/TaxCodeController";
import CurrencyService from "../../../Setup/controller/CurrencyController/CurrencyController";
import DiscountTypeService from "../../../Setup/controller/DiscountTypeController/DiscountTypeController";
import SupplierService from "../../Controller/SupplierController";
import TitleService from "../../../Setup/controller/TitleController/TitleController";
import { useNavigate, useLocation } from 'react-router-dom';
import HelpSite from "../../../Common/HelpLink";
import Website from "../../../Common/website";
import SendEmail from "../../../Common/SendEmail";
import LeadUserDefineFieldsSection from '../../../Lead/Views/LeadForms/LeadUserDefineFieldsSection';
import JobUserDefineService from "../../../Jobs/Controller/UserDefineJobController";
import { handleSubmit as handleUserDefineSubmit } from "../../../Jobs/Controller/CreateUserDefineController";

import CompanySetupController from "../../../SuperAdmin/Controller/Client/SACompanyListController";
import JasperReportService from '../../../Dashboard/Controller/JasperReportController';
import axiosInstance from '../../../../config/axiosInstance';
import BASE_URL from "../../../../config/config";
import Draggable from 'react-draggable';
import Swal from 'sweetalert2';
import CreateSupplierHistoryModal from './CreateSupplierHistoryModal';
import SupplierHistoryService from "../../Controller/SupplierHistoryController";
import ReportService from "../../../Setup/controller/ReportController/ReportController";
import TermsConditionService from "../../../Setup/controller/TermsConditionController/TermsConditionController";
import { PDFDocument } from "pdf-lib";
import { getMergedPDFBlob } from '../../../Common/ReportPDFService';
function CustomerDetail({ SupplierID, isLock, onClose, Tab }) {
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const [formData, setFormData] = useState({ PK_Supplier_ID: 0, PK_SupplierContact_ID: 0 });
    const [CountryList, setCountries] = useState([]);
    const [AccountTypesList, setAccountTypes] = useState([]);
    const [TeamList, setTeams] = useState([]);
    const [CourierList, setCouriers] = useState([]);
    const [taxCodeList, setTaxCodes] = useState([]);
    const [currencyList, setCurrenyDate] = useState([]);
    const [DiscountsList, setDiscounts] = useState([]);
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const [TitleList, setTitles] = useState([]);
    const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
    const [Email, setEmail] = useState();
    const [isChanged, setIsChanged] = useState(false);
    const [KeyNameList, setKeyNames] = useState([]);
    const [phone, setPhone] = useState();
    const [mobile, setMobile] = useState();
    const fetchKeyNames = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const KeyNames = await JobUserDefineService.GetJobUserDefine(redirectCallback, SupplierID, "5");
            setKeyNames(KeyNames || []);

            // Initialize form data with vc_Value if available
            const initialFormData = {};
            KeyNames.forEach(keyItem => {
                if (keyItem.vc_Value) {
                    initialFormData[keyItem.vc_Name] = keyItem.vc_Value;
                }
            });

            // ✅ Merge into existing formData instead of replacing it
            setFormData(prev => ({
                ...prev,
                ...initialFormData
            }));
        } catch (error) {
            console.error('Error fetching Key Names:', error);
        }
    };
    const handleFieldChange = (event, keyItem = null) => {
        const { name, value } = event.target;
        setIsChanged(true);
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };
    const handleIntegerChange = (e) => {
        const { name, value } = e.target;
        if (/^\d*$/.test(value)) {
            setFormData(prevData => ({ ...prevData, [name]: value }));
        }
    };

    const handleDecimalChange = (e) => {
        const { name, value } = e.target;
        if (/^\d*\.?\d*$/.test(value)) {
            setFormData(prevData => ({ ...prevData, [name]: value }));
        }
    };

    const handleFileChange = (e) => {
        const { name, files } = e.target;
        setFormData(prevData => ({ ...prevData, [name]: files[0] }));
    };

    useEffect(() => {
        fetchCountries();
        fetchTitle();
        fetchTaxCode();
        fetchCurrency();
        fetchDiscount();
        if (SupplierID > 0) {
            fetchSupplierDetail();
            fetchKeyNames();
            //  fetchCommunication();
        }
        else {
            resetForm();
            fetchKeyNames();
        }

    }, [SupplierID, Tab]);
    const fetchTitle = async () => {
        try {
            const listOfTitles = await TitleService.GetAllTitle();
            setTitles(listOfTitles);
            if (listOfTitles.length > 0) {
                setFormData(formData => ({
                    ...formData,
                    Title: listOfTitles[0].Title, // Assuming IssuePriorityID is the field name
                }));
            }
        } catch (error) {
            console.error('Error fetching teams:', error);
        }
    };
    const fetchCountries = async () => {
        try {
            const listOfCountries = await CountryService.GetAllCountries();
            setCountries(listOfCountries);
        } catch (error) {
            console.error('Error fetching countries:', error);
        }
    };

    const fetchTaxCode = async () => {
        try {
            const listOfTaxCodes = await TaxService.GetAllTaxCodes();
            setTaxCodes(listOfTaxCodes);
        } catch (error) {
            console.error('Error fetching tax codes:', error);
        }
    };

    const fetchCurrency = async () => {
        try {
            const listOfCurrencies = await CurrencyService.GetAllCurrencies();
            setCurrenyDate(listOfCurrencies);
        } catch (error) {
            console.error('Error fetching currencies:', error);
        }
    };

    const fetchDiscount = async () => {
        try {
            const redirectCallback = () => navigate('/');
            const listOfDiscounts = await DiscountTypeService.GetAllDiscountTypes(redirectCallback);
            setDiscounts(listOfDiscounts);
        } catch (error) {
            console.error('Error fetching discounts:', error);
        }
    };
    const location = useLocation();
    const fetchSupplierDetail = async () => {
        try {

            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            if (SupplierID > 0) {
                const SupplierDetail = await SupplierService.GetSupplierByID(redirectCallback, SupplierID);
                setFormData(SupplierDetail[0]);
            }
        } catch (error) {
            console.error('Error fetching discounts:', error);
        }
    };

    const handleFormSubmit = async (event) => {
        event.preventDefault(); // Prevent default form submission
        if (SupplierID > 0 && !isChanged) {
            return;
        }
        const redirectCallback = () => {
            navigate('/'); // Redirect to the login page
        };

        const redirectUserList = () => {
            navigate('/SupplierList?saved=true');
        };
        formData.ContactTypeID = 1;
        formData.PK_Supplier_ID = SupplierID;
        const formDataWithParts = {
            formData: formData,
            tableData: CommunicationList,

        };
        debugger;
        const message = await handleSubmit(event, formDataWithParts, setFormData, setErrors, redirectCallback, redirectUserList);
        if (message == "Data saved successfully") {
            setIsChanged(false);
            localStorage.setItem('HasRecordUpdated', "1");
            await handleUserDefineSubmit({
                JobID: SupplierID,
                fields: KeyNameList.map(key => ({
                    PK_KeyName_ID: key.PK_KeyName_ID,
                    value: formData[key.vc_Name] || ''
                }))
            });
            setShowSuccessMessage(true);
            window.scrollTo({ top: 0, behavior: 'smooth' });
            setTimeout(() => {
                setShowSuccessMessage(false);
            }, 5000);
            redirectUserList();
        }
        else {
            setShowErrorMessage(true);
            window.scrollTo({ top: 0, behavior: 'smooth' });
            setTimeout(() => {
                setShowErrorMessage(false);
            }, 5000);

        }
    };
    const resetForm = () => {

        setFormData({
            vc_SupplierName: "",
            vc_Address1: "",
            vc_Address2: "",
            vc_Address3: "",
            vc_City: "",
            vc_Postcode: "",
            vc_County: "",
            vc_Country: 0,
            vc_Fax: "",
            vc_Website: "",
            vc_Phone: "",
            vc_Title: "Mr",
            vc_FirstName: "",
            vc_SurName: "",
            vc_Email: "",
            vc_AccountRef: "",
            vc_Reference: "",

            FK_TaxCode_ID: 0,
            FK_Currency_ID: 0,
            FK_DiscountType_ID: 0,
            dec_DiscountAmount: "0.00",

        });
    };
    const handleEmailClick = async (event, email) => {
        event.stopPropagation();
        setEmail(email)
        setIsEmailModalOpen(true);
    };
    const handleCloseEmailModal = async () => {
        setIsEmailModalOpen(false);
    };
    const HelpLink = localStorage.getItem('HelpLink');

    const [imageData, setImageData] = useState(null);
    const [reportLink, setReportLink] = useState('');
    const [reportTitle, setReportTitle] = useState('');
    const [error, setError] = useState(null);
    const [pdfUrl, setPdfUrl] = useState(null); // State to store the PDF URL
    const [showPdfModal, setShowPdfModal] = useState(false);
    useEffect(() => {
        // Load image as base64
        const loadImage = async () => {
            try {
                const ClientID = localStorage.getItem('CompanyID');
                const redirectCallback = () => {
                    navigate('/'); // Redirect to the login page
                };

                const companySetup = await CompanySetupController.GetCompanyByID(redirectCallback, ClientID);
                const fileName = companySetup[0]?.FileName; // Check if fileName exists

                let imageUrl;
                if (!fileName) {
                    // Use fallback image if fileName is null or empty
                    imageUrl = 'assets/img/resources/trent.PNG';
                } else {
                    imageUrl = `${BASE_URL}/uploads/${ClientID}/Admin/CompanySetup/${fileName}`;
                }
                debugger;
                console.log("Fetching image from:", imageUrl); // Debugging

                const response = await fetch(imageUrl, {
                    method: 'GET',
                    mode: 'cors', // Ensure CORS mode
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                if (!response.ok) {
                    console.error(`Error fetching image: ${response.statusText}`);
                    return;
                }

                const blob = await response.blob();
                const reader = new FileReader();
                reader.onloadend = () => {
                    setImageData(reader.result); // Convert to base64
                };
                reader.readAsDataURL(blob);
            } catch (error) {
                console.error("Error loading image:", error);
            }
        };

        loadImage();
    }, []);

    const generatePDF = async (event) => {
        event.stopPropagation();

        try {


            const blob = await getMergedPDFBlob({
                moduleId: "5",
                navigate,
                currentInputValues: {
                    ID: SupplierID
                },
                defaultReportID: 121,
                setReportLink,
                setReportTitle,
                setError
            });

            const finalUrl = URL.createObjectURL(blob);

            setPdfUrl(finalUrl);
            setShowPdfModal(true);



        } catch (err) {
            console.error(err);
        }
    };

    const tableRef = useRef();
    const [loading, setLoading] = useState(true);
    const [CommunicationList, setCommunicationData] = useState([]);
    const [currentSupplierHistory, setCurrentSupplierHistory] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };
    const truncateText = (text, maxLength = 150) => {
        if (!text) return '';  // Return empty string if text is null or empty
        return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
    };
    const handleDeleteClick = async (event, ID) => {
        event.stopPropagation(); // Prevent the row click event

        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const redirectCallback = () => {
                        navigate('/'); // Redirect to the login page
                    };
                    await SupplierHistoryService.DeleteSupplierHistory(redirectCallback, ID)
                    //  fetchCommunication();
                    Swal.fire(
                        'Deleted!',
                        'Your record has been deleted.',
                        'success'
                    );
                } catch (error) {
                    console.error('Error deleting job:', error);
                    Swal.fire(
                        'Error!',
                        'There was a problem deleting the record.',
                        'error'
                    );
                }
            }
        });
    };
    const handleEditClick = (data, index) => {
        debugger;
        setCurrentSupplierHistory(data, index);
        setIsModalOpen(true);
    };
    const fetchCommunication = async () => {
        try {
            setCommunicationData([]);
            setLoading(true);
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const data = await SupplierHistoryService.GetAllSupplierHistory(redirectCallback, SupplierID);

            const selectedPartsData = data.map(detail => {
                const formattedDate = detail.dt_Created ? detail.dt_Created.slice(0, 10) : '';
                const AppointmentDate = detail.AppointmentDate ? detail.AppointmentDate.slice(0, 10) : '';
                const DueDate = detail.DueDate ? detail.DueDate.slice(0, 10) : '';
                const AppointmentEndDate = detail.AppointmentEndDate ? detail.AppointmentEndDate.slice(0, 10) : '';

                return {
                    PK_SupplierHistoryID: detail.PK_SupplierHistoryID,
                    snt_CommunicationType: detail.snt_CommunicationType.toString(),
                    vc_Description: detail.vc_Description,
                    dt_Created: formattedDate,
                    vc_Subject: detail.vc_Subject,
                    vc_From: detail.vc_From,
                    vc_To: detail.vc_To,
                    vc_CC: detail.vc_CC,
                    AppointmentDate: AppointmentDate,
                    StartTime: detail.StartTime,
                    Completed: detail.Completed,
                    DueDate: DueDate,
                    DueTime: detail.DueTime,
                    DisplayName: detail.DisplayName,
                    AppointmentEndDate: AppointmentEndDate,
                    EndTime: detail.EndTime,
                    UserTask: detail.UserTask,
                    AssignUserID: detail.AssignUserID,
                    StatusText: detail.StatusText,
                    Status: detail.Status,
                    EmailStatus: detail.EmailStatus,
                    IsEmailSend: detail.IsEmailSend,
                    Title: detail.Title,
                    FirstName: detail.FirstName,
                    SurName: detail.SurName,
                    FK_Supplier_ID: detail.FK_Supplier_ID,
                    FK_SupplierContact_ID: detail.FK_SupplierContact_ID,

                    // Map other fields as needed
                };
            });

            setCommunicationData(selectedPartsData);
        } catch (error) {
            console.error('Error fetching Contacts:', error);
        } finally {
            setLoading(false); // Stop loading after fetching
        }
    };
    const handleCommunicationSubmit = (CommunicationData) => {

        setIsChanged(true);
        if (Array.isArray(CommunicationData)) {
            const existingEntriesMap = new Map(CommunicationList.map(entry => [entry.ID, entry]));
            const updatedEntries = [];
            const newEntries = [];

            CommunicationData.forEach(data => {
                if (data.ID > 0) {
                    // Update existing entry if present
                    if (existingEntriesMap.has(data.ID)) {
                        updatedEntries.push(data);
                    } else {
                        // If an entry has a valid ID but doesn't exist, add it as new
                        newEntries.push(data);
                    }
                } else {
                    // Generate a unique EngineerTimeID for new entries
                    const newID = CommunicationList.length > 0
                        ? Math.max(...CommunicationList.map(row => row.ID)) + 1
                        : 1;
                    data.ID = 0;
                    newEntries.push(data);
                }
            });

            const finalTableData = [
                ...CommunicationList.filter(entry => !updatedEntries.some(updated => updated.ID === entry.ID)),
                ...updatedEntries,
                ...newEntries
            ];
            setCommunicationData(finalTableData);

            setIsModalOpen(false);
        }

    };
    const handleCloseModal = async () => {
        setIsChanged(true);
        if (SupplierID > 0) {
            //  await fetchCommunication();
        }
        setIsModalOpen(false);

    };

    const handleAddCommunicationHistory = () => {
        setCurrentSupplierHistory(null);
        setIsModalOpen(true);
    };

    const handleStart = (e, ui) => {
        e.stopPropagation();
    }
    return (

        <div>
            {showSuccessMessage && (
                <div class="alert alert-success bg-success text-light border-0 alert-dismissible fade show" role="alert">
                    Data saved successfully.
                </div>
            )}
            {showErrorMessage && (
                <div class="alert alert-danger bg-danger text-light border-0 alert-dismissible fade show" role="alert">
                    Validation Error.

                </div>
            )}
            <form onSubmit={handleFormSubmit} style={{
                display: "flex",
                flexDirection: "column",
                maxHeight: "calc(100vh - 335px)",     // IE/Edge
            }}>
                <div
                    style={{
                        // flex: 1,
                        overflowY: "auto",
                        overflowX: "hidden",
                        //  scrollbarWidth: "none", // Firefox
                        //  msOverflowStyle: "none", // IE/Edge
                    }}
                //  className="scrollable-form"
                >
                    <table style={{ width: "100%" }}>
                        <tbody>
                            <tr>
                                <td style={{ width: "13%" }}><label htmlFor="vc_SupplierName" style={{ float: "right" }}>Supplier Name:<span style={{ "color": "red" }}>*</span></label></td>
                                <td style={{ width: "37%" }}>
                                    <input type="hidden" name="PK_Supplier_ID" value={formData.PK_Supplier_ID} onChange={handleFieldChange} />
                                    <input type="hidden" name="PK_SupplierContact_ID" value={formData.PK_SupplierContact_ID} onChange={handleFieldChange} />

                                    <input type="text" className="form-control" name="vc_SupplierName" value={formData.vc_SupplierName} onChange={handleFieldChange} />
                                    {errors.vc_SupplierName && <div style={{ color: 'red' }}>{errors.vc_SupplierName}</div>}
                                </td>

                                <td style={{ width: "13%" }}><label htmlFor="vc_Title" style={{ float: "right" }}>Title:</label></td>
                                <td style={{ width: "37%" }}>

                                    <select name="vc_Title" className='form-control' value={formData.vc_Title} onChange={handleFieldChange}>
                                        {TitleList.map((title) => (
                                            <option key={title.Title} value={title.Title}>
                                                {title.Title}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.vc_Title && <div style={{ color: 'red' }}>{errors.vc_Title}</div>}
                                </td>
                            </tr>

                            <tr>

                                <td><label htmlFor="vc_AccountRef" style={{ float: "right" }}>Account No:</label></td>
                                <td>
                                    <input type="vc_AccountRef" className="form-control" name="vc_AccountRef" value={formData.vc_AccountRef} onChange={handleFieldChange} />
                                    {errors.vc_AccountRef && <div style={{ color: 'red' }}>{errors.vc_AccountRef}</div>}
                                </td>

                                <td><label htmlFor="vc_FirstName" style={{ float: "right" }}>First Name:<span style={{ "color": "red" }}>*</span></label></td>
                                <td>
                                    <input type="text" className="form-control" name="vc_FirstName" value={formData.vc_FirstName} onChange={handleFieldChange} />
                                    {errors.vc_FirstName && <div style={{ color: 'red' }}>{errors.vc_FirstName}</div>}
                                </td>
                            </tr>
                            <tr>
                                <td><label htmlFor="vc_Address1" style={{ float: "right" }}>Address:</label></td>
                                <td>
                                    <input type="text" placeholder='Address 1' className="form-control" name="vc_Address1" value={formData.vc_Address1} onChange={handleFieldChange} />
                                    {errors.vc_Address1 && <div style={{ color: 'red' }}>{errors.vc_Address1}</div>}
                                </td>
                                <td><label htmlFor="vc_SurName" style={{ float: "right" }}>Last Name:<span style={{ "color": "red" }}>*</span></label></td>
                                <td>
                                    <input type="text" className="form-control" name="vc_SurName" value={formData.vc_SurName} onChange={handleFieldChange} />
                                    {errors.vc_SurName && <div style={{ color: 'red' }}>{errors.vc_SurName}</div>}
                                </td>
                            </tr>
                            <tr>
                                <td><label htmlFor="vc_Address2" style={{ float: "right" }}></label></td>
                                <td>
                                    <input type="text" placeholder='Address 2' className="form-control" name="vc_Address2" value={formData.vc_Address2} onChange={handleFieldChange} />
                                </td>
                                <td><label htmlFor="vc_Phone" style={{ float: "right" }}>Telephone:</label></td>
                                <td>
                                    <table style={{ width: "100%" }}><tr><td>
                                        <input type="text" className="form-control" name="vc_Phone" value={formData.vc_Phone} onChange={handleFieldChange} />
                                        {errors.vc_Phone && <div style={{ color: 'red' }}>{errors.vc_Phone}</div>}
                                    </td>
                                        <td>
                                            {(SupplierID > 0) && (formData.vc_Phone != "" && formData.vc_Phone != null && formData.vc_Phone != "undefined") && (
                                                <a href={`tel:${formData.vc_Phone}`} onClick={(e) => e.stopPropagation()}>
                                                    <img src="assets/img/resources/phone.jpeg" alt="Add icon" style={{ height: "22px" }} />
                                                </a>
                                            )}
                                        </td>
                                    </tr>
                                    </table>
                                </td>
                            </tr>
                            <tr>
                                <td><label htmlFor="vc_Address3" style={{ float: "right" }}></label></td>
                                <td>
                                    <input type="text" placeholder='Address 3' className="form-control" name="vc_Address3" value={formData.vc_Address3} onChange={handleFieldChange} />
                                </td>
                                <td><label htmlFor="vc_Email" style={{ float: "right" }}>Email:</label></td>
                                <td>
                                    <table style={{ width: "100%" }}><tr><td>
                                        <input type="text" className="form-control" name="vc_Email" value={formData.vc_Email} onChange={handleFieldChange} />
                                        {errors.vc_Email && <div style={{ color: 'red' }}>{errors.vc_Email}</div>}
                                    </td>
                                        <td>
                                            {(SupplierID > 0) && (formData.vc_Email != "" && formData.vc_Email != null && formData.vc_Email != "undefined") && (

                                                <a href='#' onClick={(event) => handleEmailClick(event, formData.vc_Email)}>
                                                    <img src="assets/img/resources/email-icon.png" alt="Add icon" style={{ height: "22px" }} />
                                                </a>
                                            )}
                                        </td>
                                    </tr>
                                    </table>
                                </td>
                            </tr>
                            <tr>
                                <td><label htmlFor="vc_City" style={{ float: "right" }}>City</label></td>
                                <td>
                                    <input type="text" className="form-control" name="vc_City" value={formData.vc_City} onChange={handleFieldChange} />
                                </td>


                                <td><label htmlFor="vc_Reference" style={{ float: "right" }}>Reference</label></td>
                                <td>
                                    <input type="text" className="form-control" name="vc_Reference" value={formData.vc_Reference} onChange={handleFieldChange} />

                                </td>
                            </tr>
                            <tr>

                                <td><label htmlFor="vc_County" style={{ float: "right" }}>County</label></td>
                                <td>
                                    <input type="text" className="form-control" name="vc_County" value={formData.vc_County} onChange={handleFieldChange} />
                                </td>

                                <td><label htmlFor="AccountRef" style={{ float: "right" }}>Default Tax Code:</label></td>
                                <td>
                                    <select name="FK_TaxCode_ID" className='form-control' value={formData.FK_TaxCode_ID} onChange={handleFieldChange}>
                                        <option value="0">Select Tax Code</option>
                                        {taxCodeList.map((taxCode) => (
                                            <option key={taxCode.ID} value={taxCode.ID}>
                                                {taxCode.vc_Code} ( {taxCode.dec_Rate} )
                                            </option>
                                        ))}
                                    </select>
                                    {errors.FK_TaxCode_ID && <div style={{ color: 'red' }}>{errors.FK_TaxCode_ID}</div>}

                                </td>
                            </tr>
                            <tr>


                                <td><label htmlFor="vc_Postcode" style={{ float: "right" }}>Post Code</label></td>
                                <td>
                                    <input type="text" className="form-control" name="vc_Postcode" value={formData.vc_Postcode} onChange={handleFieldChange} />
                                </td>
                                <td><label htmlFor="vc_AccountStatus" style={{ float: "right" }}>Base Currency:</label></td>
                                <td>
                                    <select name="FK_Currency_ID" className='form-control' value={formData.FK_Currency_ID} onChange={handleFieldChange}>
                                        <option value="0">Select Currency</option>
                                        {currencyList.map((currency) => (
                                            <option key={currency.PK_Currency_ID} value={currency.PK_Currency_ID}>
                                                {currency.vc_CurrencyName}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.FK_Currency_ID && <div style={{ color: 'red' }}>{errors.FK_Currency_ID}</div>}
                                </td>
                            </tr>
                            <tr>
                                <td><label htmlFor="vc_Country" style={{ float: "right" }}>Country</label></td>
                                <td>
                                    <select name="vc_Country" className='form-control' value={formData.vc_Country} onChange={handleFieldChange}>
                                        <option value="0">Select Country</option>
                                        {CountryList.map((country) => (
                                            <option key={country.PK_Country_ID} value={country.PK_Country_ID}>
                                                {country.vc_CountryName}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.Country && <div style={{ color: 'red' }}>{errors.Country}</div>}
                                </td>
                                <td><label htmlFor="Discount" style={{ float: "right" }}>Discount:</label></td>
                                <td>
                                    <select name="FK_DiscountType_ID" className='form-control' value={formData.FK_DiscountType_ID} onChange={handleFieldChange}>
                                        <option value="0">Select Discount</option>
                                        {DiscountsList.map((discount) => (
                                            <option key={discount.PK_DiscountType_ID} value={discount.PK_DiscountType_ID}>
                                                {discount.vc_Name}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.FK_DiscountType_ID && <div style={{ color: 'red' }}>{errors.FK_DiscountType_ID}</div>}
                                </td>
                            </tr>
                            <tr>
                                <td><label htmlFor="vc_Fax" style={{ float: "right" }}>Fax</label></td>
                                <td>
                                    <input type="text" className="form-control" name="vc_Fax" value={formData.vc_Fax} onChange={handleFieldChange} />
                                </td>
                                <td><label htmlFor="dec_DiscountAmount" style={{ float: "right" }}>Amount:</label></td>
                                <td>
                                    <input type="text" className="form-control" name="dec_DiscountAmount" value={formData.dec_DiscountAmount} onChange={handleFieldChange} />
                                    {errors.dec_DiscountAmount && <div style={{ color: 'red' }}>{errors.dec_DiscountAmount}</div>}
                                </td>
                            </tr>
                            <tr>
                                <td><label htmlFor="vc_Website" style={{ float: "right" }}>Website</label></td>
                                <td>
                                    <table style={{ width: "100%" }}><tr><td>
                                        <input type="text" className="form-control" name="vc_Website" value={formData.vc_Website} onChange={handleFieldChange} />
                                    </td>
                                        <td>
                                            {(SupplierID > 0) && (formData.vc_Website != "" && formData.vc_Website != null && formData.vc_Website != "undefined") && (
                                                <Website webLink={formData.vc_Website} />
                                            )}
                                        </td>
                                    </tr>
                                    </table>
                                </td>
                            </tr>
                            {KeyNameList.length > 0 && (
                                <>
                                    <LeadUserDefineFieldsSection
                                        KeyNameList={KeyNameList}
                                        formData={formData}
                                        errors={errors}
                                        handleInputChange={handleFieldChange}
                                        handleDecimalChange={handleDecimalChange}
                                        handleIntegerChange={handleIntegerChange}
                                        handleFileChange={handleFileChange}
                                    />
                                </>
                            )}
                        </tbody>
                    </table>
                </div>

                <div className="row" style={{ "marginLeft": "0px" }}>
                    <div className="col-sm-6">
                        <button type="button" style={{ background: "#2E7D32" }} className={`btn btn-secondary btn-sm ${isLock > 0 ? 'disabled' : ''}`}
                            disabled={isLock > 0} onClick={handleAddCommunicationHistory}>
                            <i className="icofont-plus" aria-hidden="true"></i> Add Comms</button>
                    </div>
                    <div className="col-sm-6" style={{ "marginLeft": "0px", "float": "right", textAlign: "right" }}>



                        <button onClick={() => onClose(isChanged)} type="button" className={`btn btn-danger`} style={{ float: "right", "marginLeft": "5px" }}>
                            <img src="assets/img/resources/close-button-icon.png" alt="Add icon" style={{ height: "10px" }} /> Close
                        </button>
                        <button style={{ "marginLeft": "5px", float: "right" }} type="submit" className={`btn btn-primary ${parseInt(isLock) > 0 || localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} disabled={parseInt(isLock) > 0}>
                            <img src="assets/img/resources/update-icon.png" alt="Add icon" style={{ height: "10px" }} />
                            {SupplierID > 0 ? ' Update' : ' Save'}

                        </button>
                        <button style={{ "marginLeft": "5px", float: "right" }} type="button" className="btn btn-secondary" onClick={generatePDF}>
                            <img src="assets/img/resources/printer-icon.png" alt="Add icon" style={{ height: "10px" }} />  Print
                        </button>

                    </div>
                </div>
            </form>
            {isEmailModalOpen && (
                <SendEmail onClose={handleCloseEmailModal} ToEmail={Email} />
            )}
            {showPdfModal && pdfUrl && (
                <div className="modal fade show d-block" tabIndex="-1">
                    <div className="modal-dialog modal-lg">
                        <Draggable handle=".modal-content" onStart={handleStart}>
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">PDF Report</h5>
                                    <button type="button" className="close" onClick={() => setShowPdfModal(false)}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <embed src={pdfUrl} type="application/pdf" width="100%" height="600px" />
                                </div>
                            </div>
                        </Draggable>
                    </div>
                </div>
            )}
            {isModalOpen && (
                <CreateSupplierHistoryModal
                    show={isModalOpen}
                    currentSupplierHistory={currentSupplierHistory}
                    onFormSubmit={handleCommunicationSubmit}
                    onClose={handleCloseModal}
                    data={formData}
                    SupplierID={SupplierID}
                    Phone={phone}
                    Mobile={mobile}
                    ToEmail={Email}
                />
            )}
        </div>


    );
}
export default CustomerDetail;

